import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';
import { getFocusRingStyle } from '@/src/components/focusring/focusring';
import { getInteractiveStyle } from '@/src/materialui/button/interactive';

export const flowListItemButton: Components<Theme>['MuiListItemButton'] = {
  defaultProps: {
    component: 'button',
    disableRipple: true,
    // controls left and right padding
    disableGutters: false,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      // make sure to provide default typography due to browsers overwriting it with usage of button HTML tag
      ...theme.typography.body,
      position: 'relative',
      borderRadius: '0',
      // match size with ListItem
      padding: '4px 0',
      minHeight: '56px',
      // space between children (e.g. icon/avatar and text)
      gap: '8px',
      // no smooth transition to immediately toggle background color
      transition: 'none',
      // focused style
      ...getFocusRingStyle(theme, false),
      ...getInteractiveStyle(
        { backgroundColor: 'transparent' },
        { backgroundColor: theme.palette.surface.primary },
        { backgroundColor: theme.palette.surface.secondary },
      ),
      // disabled style
      '&.Mui-disabled': {
        opacity: '1',
        '&, & .MuiListItemText-root': {
          color: theme.palette.disabled.tertiary,
        },
      },
    }),
    gutters: {
      borderRadius: '4px',
      // match size with ListItem
      paddingLeft: '4px',
      paddingRight: '4px',
    },
  },
};
